module.exports = __webpack_public_path__ + "img/expovina_07(1).75ba9318.jpg";